import { Component, OnInit, Input, OnDestroy, SimpleChanges } from '@angular/core';
import { ShippingmethodService } from './shippingmethod.service';
import { ConfirmationService, MessageService } from 'primeng/api';
import { SetupService } from '../setup.service';
import { AppMainComponent } from 'src/app/app.main.component';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { AddYearPipe } from 'src/app/shared/pipes/add-year.pipe';
import { ObjectNames, Status, Severity, Answer } from '../../constants/constants';
import { TitleCasePipe } from '@angular/common';
import { AppMainService } from 'src/app/app-main.service';
import { IShippingMethodService } from '../models/shipping-method.model';


@Component({
  selector: 'app-shippingmethod',
  templateUrl: './shippingmethod.component.html',
  styleUrls: ['./shippingmethod.component.scss']
})
export class ShippingmethodComponent implements OnInit, OnDestroy {

  shippingMethodForm: FormGroup;
  allShippingMethods: any[] = [];
  allShippingMethodDropdown: any[] = [];
  @Input() financialAccounts: any[] = [];
  expandedRowsClass: {} = {};
  addEditShippingMethodHeader: string;
  displayShippingMethodAdd: boolean = false;
  isAddShippingMethod: boolean = false;
  isDisplayParent: boolean = false;
  statusDisabled: boolean = false;
  displayOrderAvailability: boolean = false;
  associatedOrders: any;
  statusConstants = Status;
  answertypeConstants = Answer;
  shippingMethodConstants = ObjectNames.setupConstants;
  invalidData: boolean = false;

  /** Ups service*/
  displayUpsServiceSelectionDialog = false;
  upsServices: any[] = [];
  selectedUpsServices: any[] = [];
  selectedParentShippingMethod: any = null;
  serviceListId: number = 0;

  constructor(private shippingMethodService: ShippingmethodService, private confirmationService: ConfirmationService, private messageService: MessageService,
    private app: AppMainComponent, private fb: FormBuilder, private setupService: SetupService, private yearPipe: AddYearPipe,
    private titlecasePipe: TitleCasePipe, private appMainService: AppMainService,) { }

  ngOnInit(): void {
    this.loadShippingMethods();
    this.setupService.getShippingMethod().subscribe(method => {
      if (method) {
        this.showAddShippingMethod();
      }
    })
    this.shippingMethodForm = this.fb.group({
      id: [0],
      createdSource: [''],
      updatedSource: [''],
      createdBy: [''],
      updatedBy: [''],
      createdDate: [''],
      updatedDate: [''],
      organizationId: [''],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      parentShippingMethodId: [0],
      financialAccountId: [null, [Validators.required]],
      isAPIConfigured: [false],
      isDefault: [false],
      isValid: [true],
      validFromDate: [''],
      validToDate: ['']
    });
  }

  loadShippingMethods() {
    this.allShippingMethodDropdown = [];
    const array = [];
    this.shippingMethodService.getShippingMethodList().subscribe((shipping) => {
      this.allShippingMethods = shipping;
      this.allShippingMethods.forEach(element => {
        if (element.statusId == Status.ACTIVE) {
          array.push(element);
        }
      });
      this.allShippingMethodDropdown = array;
    })
  }

  shippingMethodDefault(parent, type, child?) {
    if (type == ObjectNames.setupConstants.parentType && parent.isDefault) {
      this.allShippingMethods.forEach(element => {
        if (parent.childShippingMethod.length > 0) {
          parent.childShippingMethod[0].isDefault = true;
        }
        if (element.id != parent.id) {
          element.isDefault = false;
          element.childShippingMethod.forEach(el => {
            el.isDefault = false;
          });
        }
      });
      this.updateShippingMethod(parent);
    } else if (type == ObjectNames.setupConstants.childType && child.isDefault) {
      parent.childShippingMethod.forEach(element => {
        if (element.id != child.id) {
          element.isDefault = false;
        }
      });
      this.updateShippingMethod(child);
    }
  }

  showAddShippingMethod() {
    this.addEditShippingMethodHeader = ObjectNames.setupConstants.AddShippingMethodTitle;
    this.displayShippingMethodAdd = true;
    this.isAddShippingMethod = true;
    this.isDisplayParent = true;
    this.statusDisabled = false;
    this.shippingMethodForm = this.fb.group({
      id: [0],
      createdSource: [this.app.userIP],
      updatedSource: [this.app.userIP],
      createdBy: [this.app.userId],
      updatedBy: [this.app.userId],
      createdDate: [new Date().toISOString()],
      updatedDate: [new Date().toISOString()],
      organizationId: [this.app.companyId],
      name: ['', [Validators.required, Validators.pattern(/^(?!\s*$).+/)]],
      description: [''],
      statusId: [true],
      parentShippingMethodId: [0],
      financialAccountId: [null, [Validators.required]],
      isDefault: [false],
      isValid: [true],
      validFromDate: [new Date().toISOString()],
      validToDate: [this.yearPipe.transform(new Date())],
    });
  }

  showEditShippingMethod(parent, type) {
    this.addEditShippingMethodHeader = ObjectNames.setupConstants.EditShippingMethodTitle;
    this.isDisplayParent = false;
    this.statusDisabled = false;
    this.invalidData = false;
    if (parent.isDefault) {
      this.statusDisabled = true;
    }
    this.displayShippingMethodAdd = true;
    this.isAddShippingMethod = false;
    this.shippingMethodForm.patchValue(parent);
    //For Parent Financial Account
    const filteredFinancialId = this.financialAccounts?.filter(finance => finance.value?.id == parent.financialAccountId)[0];
    this.shippingMethodForm.controls['financialAccountId'].setValue(filteredFinancialId);
    //For Child Financial Account
    this.financialAccounts.forEach(finance => {
      const childAccount = finance.children?.filter(
        (child) => child.value?.id == parent.financialAccountId
      )[0];
      if (childAccount) {
        this.shippingMethodForm.controls['financialAccountId'].setValue(childAccount);
      }
    });
    //For Sub-Child Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(element => {
        const subChildAccount = element.children?.filter(
          (child) => child.value?.id == parent.financialAccountId
        )[0];
        if (subChildAccount) {
          this.shippingMethodForm.controls['financialAccountId'].setValue(subChildAccount);
        }
      });
    });
    //For forth level Financial Account
    this.financialAccounts.forEach(finance => {
      finance.children?.forEach(fnc => {
        fnc.children?.forEach(element => {
          const forthLevelChildAccount = element.children?.filter(
            (child) => child.value?.id == parent.financialAccountId
          )[0];
          if (forthLevelChildAccount) {
            this.shippingMethodForm.controls['financialAccountId'].setValue(forthLevelChildAccount);
          }
        });
      });
    });
    this.shippingMethodForm.controls['statusId'].setValue(parent.statusId == Status.ACTIVE);
    if (parent.parentShippingMethodId && type == ObjectNames.setupConstants.childType) {
      this.isDisplayParent = true;
      const filteredParent = this.allShippingMethods.filter(pt => pt.id == parent.parentShippingMethodId)[0];
      this.shippingMethodForm.controls['parentShippingMethodId'].setValue(filteredParent);
    }
  }

  saveShippingMethod(value) {
    value.statusId = (value.statusId == true ? Status.ACTIVE : Status.INACTIVE);
    value.parentShippingMethodId = (value.parentShippingMethodId ? value.parentShippingMethodId.id : 0);
    value.financialAccountId = (value.financialAccountId ? value.financialAccountId.value?.id : 0);
    value.description = value.name;
    this.invalidData = false;

    const lowerCaseNames = [];
    if (this.isAddShippingMethod) {
      if (value.parentShippingMethodId != 0) {
        const filteredParent = this.allShippingMethods.filter(parent => parent.id == value.parentShippingMethodId)[0];
        for (let s of filteredParent.childShippingMethod) {
          lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }
      } else {
        for (let s of this.allShippingMethods) {
          lowerCaseNames.push(s.name.toLowerCase().replace(/ /g, ''))
        }
      }

      if (lowerCaseNames.indexOf(value.name.toLowerCase().replace(/ /g, '')) > -1) {
        this.invalidData = true;
      } else {
        this.shippingMethodService.addShippingMethod(value).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Shipping Method Added successfully...' });
          this.loadShippingMethods();
          this.displayShippingMethodAdd = false;
        }).catch(() => {
          this.displayShippingMethodAdd = false;
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
        });
      }
    } else {
      var duplicateRecord;
      if (value.parentShippingMethodId != 0) {
        const filteredParent = this.allShippingMethods.filter(parent => parent.id == value.parentShippingMethodId)[0];
        duplicateRecord = filteredParent.childShippingMethod.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id)
      } else {
        duplicateRecord = this.allShippingMethods.find(depOb => depOb.name.toLowerCase().replace(/ /g, '') == value.name.toLowerCase().replace(/ /g, '') && depOb.id !== value.id)
      }
      if (duplicateRecord) {
        this.invalidData = true;
      } else {
        this.invalidData = false;
        this.updateShippingMethod(value);
      }

    }

  }

  updateShippingMethod(method) {
    method.updatedBy = this.app.userId;
    method.updatedDate = new Date().toISOString();
    method.updatedSource = this.app.userIP;
    this.shippingMethodService.updateShippingMethod(method).then(() => {
      this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Shipping Method Updated successfully...' });
      this.loadShippingMethods();
      this.displayShippingMethodAdd = false;
    }).catch(() => {
      this.displayShippingMethodAdd = false;
      this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while saving data...' });
    });
  }

  checkShippingMethodStatus() {
    if (!this.isAddShippingMethod && !this.shippingMethodForm.controls['statusId'].value) {
      this.setupService.checkDeleteStatus(this.shippingMethodForm.controls['id'].value, 'shippingMethod').subscribe(check => {
        if (!check.item1) {
          return
        } else {
          this.shippingMethodForm.get("statusId").setValue(true);
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
        }
      })
    }
  }

  checkDeleteStatus(parent, type, child?) {
    const deleteId = (type == ObjectNames.setupConstants.parentType ? parent.id : child.id);
    this.setupService.checkDeleteStatus(deleteId, 'shippingMethod').subscribe(check => {
      if (!check.item1) {
        this.delete(parent, type, child);
      } else {
        this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: `${check.item2}` });
      }
    })
  }

  delete(parent, type, child?) {
    const deleteId = (type == ObjectNames.setupConstants.parentType ? parent.id : child.id);
    this.confirmationService.confirm({
      message: 'Do you want to delete this Shipping Carrier?',
      header: 'Delete Confirmation',
      icon: 'pi pi-info-circle',
      accept: () => {
        this.shippingMethodService.deleteShippingMethod(deleteId).then(() => {
          this.messageService.add({ severity: Severity.Success, summary: this.titlecasePipe.transform(Severity.Success), detail: 'Deleted Successfully...' });
          if (type == ObjectNames.setupConstants.parentType) {
            const index = this.allShippingMethods.indexOf(parent);
            this.allShippingMethods.splice(index, 1);
          } else {
            const index = parent.childShippingMethod.indexOf(child);
            parent.childShippingMethod.splice(index, 1);
          }
          this.loadShippingMethods();
        }).catch(() => {
          this.messageService.add({ severity: Severity.Error, summary: this.titlecasePipe.transform(Severity.Error), detail: 'Error occurred while deleting data...' });
        });
      },
      reject: () => {
      }
    });
  }

  ngOnDestroy(): void {
    this.setupService.setShippingMethod('');
  }


  /** Ups Service */

  showUpsServiceSelectionDialog(method: any) {
    const fedaxServiceId = 2;
    this.serviceListId = method?.name?.toLowerCase() == "fedex" ? fedaxServiceId : 1
    this.upsServices = [];
    this.selectedUpsServices = [];
    this.selectedParentShippingMethod = method;
    this.appMainService.isShowSpinner("loadUpsService");
    this.shippingMethodService.getUpsServiceList(this.serviceListId)
      .subscribe({
        next: (res) => {
          this.upsServices = res && res.length > 0 ? res?.filter(r => !r.isChecked) : [];
          this.appMainService.isHideSpinner("loadUpsService");
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadUpsService");
          this.messageService.add({
            severity: Severity.Error,
            summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Error occurred ...",
          });
        },
      });
    this.displayUpsServiceSelectionDialog = true;
  }

  addUpsService() {
    this.appMainService.isShowSpinner("loadUpsService");
    this.shippingMethodService.addUpsService(this.prepareShippingMethodServices())
      .subscribe({
        next: (res) => {
          this.messageService.add({
            severity: Severity.Success,
            summary: this.titlecasePipe.transform(Severity.Success),
            detail: "Successfully added...",
          });
          this.displayUpsServiceSelectionDialog = false;
          this.appMainService.isHideSpinner("loadUpsService");
          this.loadShippingMethods();
        },
        error: (error) => {
          this.appMainService.isHideSpinner("loadUpsService");
          this.messageService.add({
            severity: Severity.Error,
            summary: this.titlecasePipe.transform(Severity.Error),
            detail: "Error occurred ...",
          });
        },
      });
  }
  prepareShippingMethodServices(): IShippingMethodService[] {
    return (this.selectedUpsServices || []).map((item) => {
      return {
        id: 0,
        createdSource: this.app.userIP,
        updatedSource: this.app.userIP,
        createdBy: this.app.user.userId,
        updatedBy: this.app.user.userId,
        createdDate: this.app._saveDateTimeWithZone(new Date()),
        updatedDate: this.app._saveDateTimeWithZone(new Date()),
        organizationId: this.app.companyId,
        name: item?.serviceName ?? "",
        description: item?.serviceCode ?? "",
        statusId: Status.ACTIVE,
        parentShippingMethodId: this.selectedParentShippingMethod?.id ?? 0,
        financialAccountId: this.selectedParentShippingMethod?.financialAccountId ?? 0,
        isDefault: false,
        isValid: true,
        isAPIConfigured: this.selectedParentShippingMethod?.isAPIConfigured ?? false,
        isEnabled: this.selectedParentShippingMethod?.isEnabled ?? false,
        validFromDate: this.app._saveDateTimeWithZone(new Date()),
        validToDate: this.app._saveDateTimeWithZone(new Date())
      };
    });
  }

  oncloseUpsServiceSelectionDialog() {
    this.displayUpsServiceSelectionDialog = false;
  }

  /** End Ups Service */

}
